(function (window, document) {
  'use strict';

  var core = window.EpicArtworkGuideCore;
  if (!core) {
    if (window.console && typeof window.console.error === 'function') {
      window.console.error('[Epic artwork guide] Core module did not load.');
    }
    return;
  }

  var bootstrap = window.__epicArtworkGuideBootstrap = window.__epicArtworkGuideBootstrap || {};
  bootstrap.readyEvents = Array.isArray(bootstrap.readyEvents) ? bootstrap.readyEvents : [];
  bootstrap.readyProducts = bootstrap.readyProducts || {};

  function findGuideForForm(form) {
    var scope = form.closest('.product-form, .product__info-container, [data-product-id]');
    if (scope) {
      var scopedGuide = scope.querySelector('[data-epic-artwork-guide]');
      if (scopedGuide) return scopedGuide;
    }

    var productId = form.getAttribute('data-epic-artwork-guide-product-id');
    if (productId) return findGuideByProductId(productId);
    return null;
  }

  function displayGuardError(guide, message, focusTarget) {
    var error = guide.querySelector('[data-epic-guide-error]');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
    guide.classList.add('epic-artwork-guide--blocked');
    guide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () {
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    }, 250);
  }

  function shouldBlockSubmission(form) {
    var guide = findGuideForForm(form);
    if (!guide) return null;

    var status = guide.querySelector('[data-epic-guide-status]');
    if (guide.getAttribute('data-epic-guide-ready') !== 'true') {
      return {
        guide: guide,
        focusTarget: status,
        message: 'The print-safe preview is not ready. Please reload the page before ordering.'
      };
    }
    if (guide.getAttribute('data-epic-has-upload') !== 'true') {
      return {
        guide: guide,
        focusTarget: status,
        message: 'Upload your artwork before adding this custom product to cart.'
      };
    }
    if (guide.getAttribute('data-epic-editor-reviewed') !== 'true') {
      return {
        guide: guide,
        focusTarget: status,
        message: 'Review the artwork and confirm the crop before adding this product to cart.'
      };
    }
    return null;
  }

  function guardFormEvent(event, form) {
    if (!form || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(form.action || '')) return;
    var blocked = shouldBlockSubmission(form);
    if (!blocked) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    displayGuardError(blocked.guide, blocked.message, blocked.focusTarget);
  }

  function installGlobalGuard() {
    if (bootstrap.guardInstalled) return;
    bootstrap.guardInstalled = true;

    document.addEventListener('submit', function (event) {
      guardFormEvent(event, event.target);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(
        'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]'
      );
      if (button) guardFormEvent(event, button.form);
    }, true);
  }

  function installReadyCapture() {
    if (bootstrap.captureInstalled) return;
    bootstrap.captureInstalled = true;
    window.addEventListener('upload:ready', function (event) {
      if (!event || !event.detail) return;
      bootstrap.readyEvents.push({ target: event.target, field: event.detail });
      consumeReadyEvents();
    }, true);
  }

  function findGuideByProductId(productId) {
    var guides = document.querySelectorAll('[data-epic-artwork-guide]');
    for (var index = 0; index < guides.length; index += 1) {
      if (guides[index].getAttribute('data-product-id') === String(productId)) return guides[index];
    }
    return null;
  }

  function isPurchaseForm(form) {
    if (!form || form.classList.contains('js-instalments-form')) return false;
    if (form.classList.contains('js-product-form')) return true;
    return Boolean(form.querySelector(
      '[name="add"], button[type="submit"], input[type="submit"]'
    ));
  }

  function purchaseFormIn(scope) {
    if (!scope) return null;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    for (var index = 0; index < forms.length; index += 1) {
      if (isPurchaseForm(forms[index])) return forms[index];
    }
    return null;
  }

  function findProductForm(guide) {
    var scope = guide.parentElement &&
      guide.parentElement.closest('.product-form, .product__info-container, [data-product-id]');
    var scopedForm = purchaseFormIn(scope);
    if (scopedForm) return scopedForm;

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var purchaseForms = [];
    for (var index = 0; index < forms.length; index += 1) {
      if (isPurchaseForm(forms[index])) purchaseForms.push(forms[index]);
    }
    return purchaseForms.length === 1 ? purchaseForms[0] : null;
  }

  function setStatus(guide, state, message) {
    guide.setAttribute('data-epic-guide-state', state);
    var status = guide.querySelector('[data-epic-guide-status]');
    if (status) status.textContent = message;
  }

  function clearError(guide) {
    var error = guide.querySelector('[data-epic-guide-error]');
    if (error) error.hidden = true;
    guide.classList.remove('epic-artwork-guide--blocked');
  }

  function ensurePropertyInput(form, name) {
    var input = form.querySelector('input[data-epic-guide-property="' + name + '"]');
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.setAttribute('data-epic-guide-property', name);
    input.disabled = true;
    form.appendChild(input);
    return input;
  }

  function syncReviewRecord(guide, profile) {
    var form = findProductForm(guide);
    if (!form) return;

    form.setAttribute('data-epic-artwork-guide-product-id', profile.productId);
    var reviewRecord = ensurePropertyInput(form, '_artwork_safe_area_reviewed');
    var approved = guide.getAttribute('data-epic-guide-ready') === 'true' &&
      guide.getAttribute('data-epic-has-upload') === 'true' &&
      guide.getAttribute('data-epic-editor-reviewed') === 'true';
    reviewRecord.value = [
      core.GUIDE_VERSION,
      core.SAFE_AREA_CM + 'cm',
      profile.widthCm + 'x' + profile.heightCm + 'cm'
    ].join(';');
    reviewRecord.disabled = !approved;
  }

  function disableExpressCheckout(guide) {
    var scope = guide.parentElement &&
      guide.parentElement.closest('.product-form, .product__info-container, [data-product-id]');
    if (!scope) return;
    var expressButtons = scope.querySelectorAll(
      '.shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]'
    );
    for (var index = 0; index < expressButtons.length; index += 1) {
      expressButtons[index].hidden = true;
      expressButtons[index].setAttribute('aria-hidden', 'true');
      expressButtons[index].setAttribute('data-epic-artwork-guide-disabled', 'true');
    }
  }

  function initializeGuide(guide) {
    var productId = guide.getAttribute('data-product-id');
    var profile = core.getProfile(productId);
    if (!profile) {
      guide.hidden = true;
      return;
    }

    guide.hidden = false;
    disableExpressCheckout(guide);
    if (guide.__epicArtworkGuideInitialized) {
      syncReviewRecord(guide, profile);
      return;
    }
    guide.__epicArtworkGuideInitialized = true;
    guide.setAttribute('data-epic-guide-ready', 'false');
    guide.setAttribute('data-epic-has-upload', 'false');
    guide.setAttribute('data-epic-editor-reviewed', 'false');
    var sizeLabel = guide.querySelector('[data-epic-guide-size]');
    if (sizeLabel) sizeLabel.textContent = profile.label;
    var safeAreaLabels = guide.querySelectorAll('[data-epic-safe-area-cm]');
    for (var labelIndex = 0; labelIndex < safeAreaLabels.length; labelIndex += 1) {
      safeAreaLabels[labelIndex].textContent = String(core.SAFE_AREA_CM);
    }

    syncReviewRecord(guide, profile);

    if (!guide.__epicConnectionTimer) {
      guide.__epicConnectionTimer = window.setTimeout(function () {
        if (guide.getAttribute('data-epic-guide-ready') === 'true') return;
        setStatus(
          guide,
          'error',
          'The print-safe preview did not connect. Reload this page before uploading or ordering.'
        );
      }, 8000);
    }
  }

  function productIdForReadyEvent(record) {
    var target = record && record.target;
    var uploadRoot = target && target.closest ? target.closest('[data-upload-lift]') : null;
    if (!uploadRoot && target && target.matches && target.matches('[data-upload-lift]')) uploadRoot = target;
    if (uploadRoot) return uploadRoot.getAttribute('data-upload-lift');

    var config = record && record.field && record.field.config;
    return config && (config.productId || config.product_id) ? String(config.productId || config.product_id) : '';
  }

  function placeGuideBeforeUpload(record, guide) {
    var target = record && record.target;
    if (!target || !target.closest) return;
    var uploadRoot = target.closest('[data-upload-lift], [data-upload-field]');
    if (!uploadRoot || !uploadRoot.parentNode || guide === uploadRoot || guide.contains(uploadRoot)) return;
    uploadRoot.parentNode.insertBefore(guide, uploadRoot);
  }

  function patchUploadField(field, profile) {
    if (!field || typeof field.updateConfig !== 'function') {
      throw new Error('Upload-Lift did not expose updateConfig.');
    }
    var fieldConfig = field.config || {};
    if (
      fieldConfig.imageEditor !== true ||
      fieldConfig.imageEditorPintura !== true ||
      fieldConfig.imageOriginal !== true ||
      fieldConfig.imageEditorCropRestrict !== true
    ) {
      throw new Error('Upload-Lift artwork safety settings do not match the verified contract.');
    }
    var cropRatios = fieldConfig.imageEditorCropRatios;
    var primaryRatio = Array.isArray(cropRatios) && cropRatios.length ? cropRatios[0].value : null;
    if (!core.cropRatioMatchesProfile(profile, primaryRatio)) {
      throw new Error('Upload-Lift crop ratio does not match the physical product size.');
    }

    var currentPintura = fieldConfig.imageEditorPinturaConfig || {};
    if (currentPintura.cropShape) {
      throw new Error('Upload-Lift shape crops require a separate overlay integration.');
    }
    var currentOptions = currentPintura.options || {};
    var currentHook = currentOptions.willRenderCanvas;
    if (currentHook && currentHook.epicArtworkGuideVersion === core.GUIDE_VERSION) return;

    var nextHook = core.createWillRenderCanvas(profile, currentHook);
    var nextPintura = Object.assign({}, currentPintura, {
      options: Object.assign({}, currentOptions, { willRenderCanvas: nextHook })
    });
    field.updateConfig({ imageEditorPinturaConfig: nextPintura });

    var installedHook = field.config &&
      field.config.imageEditorPinturaConfig &&
      field.config.imageEditorPinturaConfig.options &&
      field.config.imageEditorPinturaConfig.options.willRenderCanvas;
    if (!installedHook || installedHook.epicArtworkGuideVersion !== core.GUIDE_VERSION) {
      throw new Error('Upload-Lift did not retain the print-safe canvas hook.');
    }
  }

  function uploadCount(field) {
    if (!field || typeof field.fileCount !== 'function') return null;
    var count = Number(field.fileCount());
    return Number.isFinite(count) ? count : null;
  }

  function setUploadState(guide, field, fallback) {
    var count = uploadCount(field);
    var hasUpload = count === null ? Boolean(fallback) : count > 0;
    guide.setAttribute('data-epic-has-upload', hasUpload ? 'true' : 'false');
    return hasUpload;
  }

  function bindEditorEvents(record, guide, profile) {
    var target = record && record.target;
    var uploadRoot = target && target.closest ? target.closest('[data-upload-field]') : null;
    if (!uploadRoot || uploadRoot.__epicArtworkGuideEventsBound) return;
    uploadRoot.__epicArtworkGuideEventsBound = true;
    var field = record.field;
    var reviewBeforeOpen = false;
    var confirmedCurrentOpen = false;

    uploadRoot.addEventListener('upload:editor:open', function () {
      confirmedCurrentOpen = false;
      reviewBeforeOpen = guide.getAttribute('data-epic-editor-reviewed') === 'true';
      guide.setAttribute('data-epic-editor-reviewed', 'false');
      syncReviewRecord(guide, profile);
      setStatus(
        guide,
        'editing',
        'In the editor: fill the entire crop with background and keep important details inside the orange line.'
      );
    });
    uploadRoot.addEventListener('upload:editor:confirm', function () {
      confirmedCurrentOpen = true;
      guide.setAttribute('data-epic-editor-reviewed', 'true');
      syncReviewRecord(guide, profile);
      setStatus(
        guide,
        'ready',
        setUploadState(guide, field, false)
          ? 'Artwork checked and ready to add to cart.'
          : 'Crop reviewed. Finishing the artwork upload…'
      );
      clearError(guide);
    });
    uploadRoot.addEventListener('upload:editor:cancel', function () {
      if (confirmedCurrentOpen) {
        confirmedCurrentOpen = false;
        return;
      }
      guide.setAttribute('data-epic-editor-reviewed', reviewBeforeOpen ? 'true' : 'false');
      syncReviewRecord(guide, profile);
      setStatus(
        guide,
        reviewBeforeOpen ? 'ready' : 'editing',
        reviewBeforeOpen
          ? 'Edit cancelled; the previously confirmed crop is still selected.'
          : 'Crop review is required before adding this product to cart.'
      );
    });
    uploadRoot.addEventListener('upload:added', function () {
      setUploadState(guide, field, true);
      syncReviewRecord(guide, profile);
      if (guide.getAttribute('data-epic-editor-reviewed') === 'true') {
        setStatus(
          guide,
          'ready',
          'Artwork checked and ready to add to cart.'
        );
        clearError(guide);
      }
    });
    uploadRoot.addEventListener('upload:removed', function () {
      setUploadState(guide, field, false);
      guide.setAttribute('data-epic-editor-reviewed', 'false');
      syncReviewRecord(guide, profile);
      setStatus(guide, 'ready', 'Artwork removed. Upload a file to review the print-safe crop.');
    });
  }

  function connectReadyEvent(record) {
    var productId = productIdForReadyEvent(record);
    if (!productId) return false;
    var guide = findGuideByProductId(productId);
    if (!guide) return false;
    var profile = core.getProfile(productId);
    if (!profile) return true;

    try {
      placeGuideBeforeUpload(record, guide);
      disableExpressCheckout(guide);
      patchUploadField(record.field, profile);
      bindEditorEvents(record, guide, profile);
      guide.setAttribute('data-epic-guide-ready', 'true');
      bootstrap.readyProducts[productId] = true;
      if (guide.__epicConnectionTimer) {
        window.clearTimeout(guide.__epicConnectionTimer);
        guide.__epicConnectionTimer = null;
      }
      setStatus(
        guide,
        'ready',
        'Upload artwork; the editor will show the 2.5 cm print-safe guide.'
      );
      syncReviewRecord(guide, profile);
      return true;
    } catch (error) {
      guide.setAttribute('data-epic-guide-ready', 'false');
      setStatus(
        guide,
        'error',
        'The print-safe preview could not start. Reload this page before uploading or ordering.'
      );
      if (window.console && typeof window.console.error === 'function') {
        window.console.error('[Epic artwork guide] Upload-Lift connection failed.', error);
      }
      return true;
    }
  }

  function consumeReadyEvents() {
    var pending = [];
    for (var index = 0; index < bootstrap.readyEvents.length; index += 1) {
      if (!connectReadyEvent(bootstrap.readyEvents[index])) pending.push(bootstrap.readyEvents[index]);
    }
    bootstrap.readyEvents = pending;
  }

  function scanGuides() {
    var guides = document.querySelectorAll('[data-epic-artwork-guide]');
    for (var index = 0; index < guides.length; index += 1) initializeGuide(guides[index]);
    consumeReadyEvents();
  }

  installGlobalGuard();
  installReadyCapture();
  bootstrap.consume = consumeReadyEvents;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanGuides, { once: true });
  } else {
    scanGuides();
  }

  if (typeof window.MutationObserver === 'function') {
    new window.MutationObserver(function (mutations) {
      var needsScan = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches('[data-epic-artwork-guide]') ||
            node.matches('.shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]') ||
            node.querySelector('[data-epic-artwork-guide], .shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]')
          );
        });
      });
      if (needsScan) scanGuides();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})(window, document);
